import { createContext, useContext, useEffect, useRef } from "react";

export const ModalActionContext = createContext<{
  isBusy: boolean;
  setActionPending(actionId: symbol, pending: boolean): void;
}>({
  isBusy: false,
  setActionPending: () => {},
});

export function useModalAction(pending: boolean) {
  const { isBusy, setActionPending } = useContext(ModalActionContext);
  const actionId = useRef(Symbol("modal-action"));

  useEffect(() => {
    const currentId = actionId.current;
    setActionPending(currentId, pending);

    return () => setActionPending(currentId, false);
  }, [pending, setActionPending]);

  function beginAction() {
    setActionPending(actionId.current, true);
  }

  return { isBusy, beginAction };
}
